import { Component, Input } from '@angular/core';
import { TimeCycleCategory, TimeCycleTooltipBadgeConfig } from '@models';

@Component({
  selector: 'time-cycle-chart-tooltip',
  templateUrl: './time-cycle-chart-tooltip.component.html',
  styleUrl: './time-cycle-chart-tooltip.component.scss'
})
export class TimeCycleChartTooltipComponent {
  @Input() title = '';
  @Input() weeks: number | undefined = undefined;
  @Input() status: TimeCycleCategory | null = null;

  private badgeMap: Partial<Record<TimeCycleCategory, TimeCycleTooltipBadgeConfig>> = {
    Equal: {
      label: 'Equal',
      textColor: '#00399C',
      backgroundColor: '#DFEEFF'
    },
    Ahead: {
      label: 'Ahead',
      textColor: '#005512',
      backgroundColor: '#D9FBE2'
    },
    Behind: {
      label: 'Behind',
      textColor: '#790000',
      backgroundColor: '#FDE4E4'
    },
    'Benchmark not available': {
      label: 'Unavailable',
      textColor: '#1b1b1d',
      backgroundColor: '#e0e0e0'
    }
  };

  get badge(): TimeCycleTooltipBadgeConfig | null {
    if (!this.status) {
      return null;
    }

    return this.badgeMap[this.status] ?? null;
  }

  get suffixText(): string {
    switch (this.status) {
      case 'Ahead':
        return 'of industry benchmark';
      case 'Equal':
        return 'to industry benchmark';
      case 'Behind':
        return 'of industry benchmark';
      case 'Benchmark not available':
        return 'industry benchmark';
      default:
        return '';
    }
  }
}
